export default __webpack_public_path__ + "1d8b1d1ef0b9b27b3a2e7312a5a92cae.png";